import { Controller } from "@hotwired/stimulus"
import "jquery.tagsinput"

// Example on `app/views/users/new.haml`:
//   = form_for @user, html: {
//       id: 'user_add_form',
//       class: 'form-horizontal',
//       data: {
//         controller: 'users--new-form ajax-form',
//         'users--new-form-list-path-value': users_service_root_path(@current_app),
//         action: 'submit->users--new-form#beforeSubmit ' \
//                 'submit->ajax-form#submit ' \
//                 'ajax-form:success->users--new-form#onSuccess',
//         turbo: false,
//       },
//     }, method: :post, url: users_service_create_user_path do |f|

const HEX = /^[0-9A-Fa-f]+$/
const WEBSITE = /^(https?:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(([0-9]{1,5})?\/.*)?$/i
const EMAIL = /^[A-Z0-9_\.%\+\-']+@(?:[A-Z0-9\-]+\.)+(?:[A-Z]{2,50}|museum|travel|social|email)$/i
const ALLNUM_ALLPUNCT = /^[-A-Za-z0-9\]\[\!\"\#\$\%\&\'\(\)\*\+\,\.\/\:\;\<\=\>\?\@\\\^\_\`\{\|\}\~]+$/
const LOGIN_REGEX = /^[a-zA-Z0-9-_+@\.]+$/
const FULL_NAME = /^[^><;]{1,200}$/
const PHONE = /^[-0-9()+*#]+$/

export default class extends Controller {
  static values = { listPath: String }

  connect() {
    const $form = $(this.element)
    this.$form = $form

    $form.trigger("reset")

    const $tags = $form.find("#tags")
    if ($tags.length) {
      $tags.tagsInput({
        interactive: true,
        width: "100%",
        height: "34px",
        defaultText: "",
        hint_selector: "#tags-hint",
      })
    }

    this.#ensureRegexValidator()

    $form.validate({
      onsubmit: false,
      rules: {
        "user[login]": {
          required: "#user_email:blank",
          regex: LOGIN_REGEX,
          minlength: 1,
          maxlength: 100,
        },
        "user[full_name]": {
          regex: FULL_NAME,
          minlength: 1,
          maxlength: 200,
        },
        "user[website]": {
          required: false,
          regex: WEBSITE,
          url: true,
          minlength: 3,
          maxlength: 200,
        },
        "user[email]": {
          required: "#user_login:blank",
          regex: EMAIL,
        },
        "user[password]": {
          required: true,
          regex: ALLNUM_ALLPUNCT,
          minlength: 8,
          maxlength: 50,
        },
        "user[password_confirmation]": {
          equalTo: "#user_password",
        },
        "user[facebook_id]": {
          regex: HEX,
          maxlength: 40,
        },
        "user[external_user_id]": { number: true },
        "user[blob_id]": { number: true },
        "user[phone]": { regex: PHONE, minlength: 0, maxlength: 50 },
      },
      messages: {
        "user[email]": {
          regex: "Email expected",
          required: "This field required (or login)",
        },
        "user[login]": {
          required: "This field required (or email)",
          regex: "Bad format",
        },
        "user[website]": { regex: "Website address expected" },
        "user[facebook_id]": { regex: "Facebook ID expected" },
        "user[phone]": { regex: "Bad format" },
      },
      errorPlacement(error, element) {
        $(error).before("<br />").insertAfter(element).hide().slideDown()
      },
    })
  }

  disconnect() {
    if (this.$form) {
      const validator = this.$form.data("validator")
      if (validator) {
        validator.resetForm()
        this.$form.removeData("validator")
      }
      this.$form.find("label.error").remove()

      const $tags = this.$form.find("#tags")
      if ($tags.length) {
        const tagsId = $tags.attr("id")
        const wrapper = document.getElementById(`${tagsId}_tagsinput`)
        if (wrapper) wrapper.remove()
        $tags.show()
      }
    }
    this.$form = null
  }

  beforeSubmit(event) {
    if (!this.$form?.valid()) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  onSuccess(event) {
    event.preventDefault()
    const { payload } = event.detail || {}
    localStorage.setItem("mymessage", (payload && payload.message) || "")
    window.location.replace(this.listPathValue || "/")
  }

  #ensureRegexValidator() {
    if (!$.validator || $.validator.methods.regex) return

    $.validator.addMethod(
      "regex",
      function (value, element, regexp) {
        return this.optional(element) || regexp.test(value)
      },
      "Please check your input.",
    )
  }
}
